import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { closeReportModal } from '../../redux/slices/reportSlice';
import ReportProblemForm from './ReportProblemForm';

// Redux-gated wrapper mounted once at the App root (like LoginModal). The
// form itself is presentational so the ErrorBoundary can also render it
// directly when the React tree has crashed.
const ReportProblemModal = () => {
    const dispatch = useDispatch();
    const { open, source, errorContext } = useSelector((state) => state.report);
    const activeTab = useSelector((state) => state.app.activeTab);
    const activeCategory = useSelector((state) => state.app.activeCategory);

    useEffect(() => {
        if (!open) return;
        try {
            window.electron?.analytics?.track('problem_report_opened', {
                source: source || 'unknown',
                feature: activeTab || null,
            });
        } catch { /* analytics is best-effort */ }
    }, [open, source, activeTab]);

    if (!open) return null;

    const feature = activeTab || (activeCategory ? `category:${activeCategory}` : null);

    return (
        <ReportProblemForm
            feature={feature}
            source={source}
            errorContext={errorContext}
            onClose={() => dispatch(closeReportModal())}
        />
    );
};

export default ReportProblemModal;
